import {
  Component,
  OnChanges,
  ElementRef,
  Input,
  Output,
  ViewChild,
  EventEmitter,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { NotificationService } from "../../../services/notification.service";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { NgClass } from "@angular/common";
import { SvgIconComponent } from "angular-svg-icon";
import { MatTooltip } from "@angular/material/tooltip";
import { FormsModule } from "@angular/forms";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-searchbar-number",
  templateUrl: "./searchbar-number.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./searchbar-number.component.scss"],
  imports: [
    NgClass,
    SvgIconComponent,
    MatTooltip,
    FormsModule,
    MatIcon,
    TranslateModule
  ]
})
export class SearchbarNumberComponent implements OnChanges {
  private readonly notifier: NotificationService;

  @ViewChild("inputNumberRef") inputNumberRef: ElementRef;

  @Output() number: EventEmitter<number> = new EventEmitter<number>();

  @Input() label: string = "";
  @Input() icon: string = "";
  @Input() inputActive: boolean = false;
  @Input() inputData: string = "";

  private savedInputData: string = "";

  constructor(
    private notifierService: NotificationService,
    private translate: TranslateService
  ) {
    this.notifier = notifierService;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inputData) {
      this.savedInputData = this.inputData;
    }
  }

  public inputFocus(): void {
    this.inputNumberRef.nativeElement.focus();
  }

  public inputEnter(): void {
    const data: number = parseInt(this.inputData, 10);

    if (!isNaN(data)) {
      this.number.emit(data);
      this.inputNumberRef.nativeElement.blur();
    } else {
      this.inputData = "";
      this.number.emit(undefined);
      this.translate.get("filter.number.error").subscribe((msg) => {
        this.notifier.error(msg);
      });
    }
    this.inputNumberRef.nativeElement.blur();
  }

  public inputBlur(): void {
    if (!this.inputData && !this.savedInputData) return;

    const data: number = parseInt(this.inputData, 10);

    if (isNaN(data)) {
      if (!this.savedInputData) {
        this.inputData = "";
        this.translate.stream("filter.number.error").subscribe((msg) => {
          this.notifier.error(msg);
        });
      } else {
        this.inputData = this.savedInputData;
      }
    } else {
      if (this.inputData !== this.savedInputData) {
        this.number.emit(data);
      }
    }
  }

  public clearInput(): void {
    this.inputData = "";
    this.number.emit(undefined);
  }
}
